import { Mapper } from 'src/base/mapper'
import { ActivityTypeEntity } from 'src/data/entities/base.entity'
import { ActivityTypeModel } from 'src/domain/models/base.model'

export class ActivityMapper extends Mapper<ActivityTypeEntity, ActivityTypeModel> {
	mapFrom(param: ActivityTypeEntity): ActivityTypeModel {
		return {
			remark: param.remark,
			dateCreated: param.dateCreated,
			createByUserName: param.createByUserName,
		}
	}

	mapTo(param: ActivityTypeModel): ActivityTypeEntity {
		return {
			activityId: null,
			clientId: null,
			referenceId: null,
			activityType: null,
			statusId: null,
			statusName: null,
			remark: param.remark,
			createdByUserId: null,
			createByUserName: param.createByUserName,
			dateCreated: param.dateCreated,
			pictureUrl: null,
			userName: null,
		}
	}
}
